import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const MenuCarousel = () => {
  const images = [
    "/images/menu1.jpeg",
    "/images/menu2.jpeg",
    "/images/menu3.jpeg",
  ];

  const [selectedImage, setSelectedImage] = useState(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    autoplay: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="carousel-container" id="menu">
      <Slider {...settings}>
        {images.map((src, index) => (
          <div key={index} className="slide">
            <img
              src={src}
              alt={`Pizza ${index + 1}`}
              className="carousel-image"
              onClick={() => setSelectedImage(src)}
              style={{ cursor: "pointer" }}
            />
          </div>
        ))}
      </Slider>

      {/* Modal for fullscreen image */}
      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Zoomed pizza" className="modal-image" />
        </div>
      )}
    </div>
  );
};

export default MenuCarousel;
